import React from "react"
import Skeleton from "../../../components/Skeleton"

const FinanceListLoadingItemDesktop = ({ isPurchases }) => (
  <div style={{ display: "flex", marginTop: 15 }}>
    <Skeleton style={{ height: 20 }} />
    <Skeleton style={{ height: 40 }} />
    <Skeleton style={{ height: 40 }} />
    <Skeleton style={{ height: 20 }} />
    {!isPurchases && <Skeleton style={{ height: 20 }} />}
    {!isPurchases && <Skeleton style={{ height: 20 }} />}
    {!isPurchases && <Skeleton style={{ height: 20 }} />}
  </div>
)

const FinanceListLoadingItemMobile = ({ isPurchases }) => (
  <div style={{ marginTop: 25 }}>
    <div style={{ display: "flex" }}>
      <Skeleton style={{ height: 20 }} />
      <Skeleton style={{ height: 20 }} />
    </div>
    <div style={{ display: "flex" }}>
      <Skeleton style={{ height: 20 }} />
      <Skeleton style={{ height: 20 }} />
    </div>
    <div style={{ display: "flex" }}>
      <Skeleton style={{ height: 20 }} />
      <Skeleton style={{ height: 20 }} />
    </div>
    <div style={{ display: "flex" }}>
      <Skeleton style={{ height: 20 }} />
      <Skeleton style={{ height: 20 }} />
    </div>
    {!isPurchases && (
      <React.Fragment>
        <div style={{ display: "flex" }}>
          <Skeleton style={{ height: 20 }} />
          <Skeleton style={{ height: 20 }} />
        </div>
        <div style={{ display: "flex" }}>
          <Skeleton style={{ height: 20 }} />
          <Skeleton style={{ height: 20 }} />
        </div>
        <Skeleton style={{ height: 30, width: "75%", margin: "10px auto" }} />
      </React.Fragment>
    )}
  </div>
)

export const FinanceListLoading = ({ isMobile, isPurchases = false }) => (
  <React.Fragment>
    {isMobile ? (
      <React.Fragment>
        <FinanceListLoadingItemMobile isPurchases={isPurchases} />
        <FinanceListLoadingItemMobile isPurchases={isPurchases} />
        <FinanceListLoadingItemMobile isPurchases={isPurchases} />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <FinanceListLoadingItemDesktop isPurchases={isPurchases} />
        <FinanceListLoadingItemDesktop isPurchases={isPurchases} />
        <FinanceListLoadingItemDesktop isPurchases={isPurchases} />
        <FinanceListLoadingItemDesktop isPurchases={isPurchases} />
        <FinanceListLoadingItemDesktop isPurchases={isPurchases} />
        <FinanceListLoadingItemDesktop isPurchases={isPurchases} />
      </React.Fragment>
    )}
  </React.Fragment>
)


// WEBPACK FOOTER //
// ./src/containers/FinancePage/FinanceList/FinanceListLoading.tsx